export const links = {
    common: {
        notice: `${DOC_PUBLIC_PATH}notice_precontractuelle.pdf`,
        ipid: `${DOC_PUBLIC_PATH}IPID.pdf`,
    },
    tiersPlus: {
        fiche: `${DOC_PUBLIC_PATH}fiche_information_TIERS.pdf`
    },
    toutRisques: {
        fiche: `${DOC_PUBLIC_PATH}fiche_information_TR.pdf`
    },
    toutRisquesPlus: {
        fiche: `${DOC_PUBLIC_PATH}fiche_information_TR_PLUS.pdf`
    },
};

export const buildKiamoTaskBodyForEvidence = (personId, policyId, codeProduit) => ({
    personId : personId,
    productId : codeProduit,
    serviceType : "verificationPiece",
    description : `Nouvelle(s) pièce(s) reçue(s), merci de les contrôler
        Origin : INT 
        Référence : ${policyId} 
        Personne : ${personId} 
        Merci de la (les) contrôler.`,
    activityType : "souscription",
    entityId : policyId,
    origin : "INT",
    entity : "gestion"
})